
import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

import { IconSize, IconVariation } from './icon.model';

@Component({
	selector: 'sl-icon',
	templateUrl: './icon.component.html',
	styleUrl: './icon.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class IconComponent {
	readonly size = input<IconSize>(IconSize.Regular);
	readonly icon = input<string>();
	readonly variation = input<IconVariation>();

	@HostBinding('class') get classes(): Record<string, boolean> {
		return {
			'sl-icon': true,
			'material-symbols-outlined': true,
			[`sl-icon--${this.size()}`]: !!this.size(),
			[`sl-icon-variation--${this.variation()}`]: !!this.variation()
		};
	}
}
